import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IGetExercisePayload,
  IExerciseState,
  ICreateExercisePayload,
  IUpdateExercisePayload,
  IDeleteExercisePayload,
} from "../../../interfaces/store/exercise-interface";

const initialState: IExerciseState = {
  exercise: null,
  error: null,
  loading: false,
  requestState: "prepare",
  operation: null,
};

const _getExerciseStart = (
  state: IExerciseState,
  { payload }: PayloadAction<IGetExercisePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getExerciseSuccess = (
  state: IExerciseState,
  { payload }: PayloadAction<any>
) => {
  state.exercise = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getExerciseFailed = (
  state: IExerciseState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetExercise = (state: IExerciseState) => {
  state.exercise = null;
  state.error = null;
  state.loading = false;
  state.requestState = "prepare";
  state.operation = null;
};

const _createExerciseStart = (
  state: IExerciseState,
  { payload }: PayloadAction<ICreateExercisePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "create";
};

const _createExerciseSuccess = (
  state: IExerciseState,
  { payload }: PayloadAction<any>
) => {
  state.exercise = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _createExerciseFailed = (
  state: IExerciseState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.exercise = null;
  state.requestState = "error";
};

const _updateExerciseStart = (
  state: IExerciseState,
  { payload }: PayloadAction<IUpdateExercisePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateExerciseSuccess = (
  state: IExerciseState,
  { payload }: PayloadAction<any>
) => {
  state.exercise = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _updateExerciseFailed = (
  state: IExerciseState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.exercise = null;
  state.requestState = "error";
};

const _deleteExerciseStart = (
  state: IExerciseState,
  { payload }: PayloadAction<IDeleteExercisePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "delete";
};

const _deleteExerciseSuccess = (
  state: IExerciseState,
  { payload }: PayloadAction<any>
) => {
  state.exercise = null;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _deleteExerciseFailed = (
  state: IExerciseState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.exercise = null;
  state.requestState = "error";
};

const ExerciseSlice = createSlice({
  name: "exercise",
  initialState,
  reducers: {
    getExerciseStart: _getExerciseStart,
    getExerciseSuccess: _getExerciseSuccess,
    getExerciseFailed: _getExerciseFailed,
    resetExercise: _resetExercise,
    createExerciseStart: _createExerciseStart,
    createExerciseSuccess: _createExerciseSuccess,
    createExerciseFailed: _createExerciseFailed,
    updateExerciseStart: _updateExerciseStart,
    updateExerciseSuccess: _updateExerciseSuccess,
    updateExerciseFailed: _updateExerciseFailed,
    deleteExerciseStart: _deleteExerciseStart,
    deleteExerciseSuccess: _deleteExerciseSuccess,
    deleteExerciseFailed: _deleteExerciseFailed,
  },
});

export const {
  getExerciseStart,
  getExerciseSuccess,
  getExerciseFailed,
  resetExercise,
  createExerciseStart,
  createExerciseSuccess,
  createExerciseFailed,
  updateExerciseStart,
  updateExerciseSuccess,
  updateExerciseFailed,
  deleteExerciseStart,
  deleteExerciseSuccess,
  deleteExerciseFailed,
} = ExerciseSlice.actions;
export default ExerciseSlice.reducer;
